import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { Navigate } from 'react-router-dom';
import { fromAccounts, fromBillingInformation, fromPaymentMethod, useAppDispatch } from '../../store';
import { Page } from '../../components/page';
import { notFound, useQuery } from '../../routes';
import { PaymentMethodSection } from './PaymentMethodSection';
import { BillingInfoSection } from './BillingInfoSection';

const useStyles = makeStyles(theme => ({
  pageTitle: {
    fontFamily: "'Inter Tight', sans-serif",
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: '-.01em',
    color: '#16141d',
  },
  pageSubtitle: {
    fontSize: 13.5,
    color: '#5b6661',
    marginTop: theme.spacing(0.625),
  },
}));

const PaymentMethod = () => {
  const classes = useStyles();
  const { get } = useQuery();
  const dispatch = useAppDispatch();
  const accountId = Number(get('accountId'));

  const fetchInfo = async () => {
    if (accountId) {
      await Promise.all([
        dispatch(fromAccounts.doCheckPublicDomain(accountId)),
        dispatch(fromPaymentMethod.doGetDefaultPaymentMethod()),
        dispatch(fromBillingInformation.doGetBillingInformation(accountId)),
      ]);
    }
  };

  if (!accountId || Number.isNaN(accountId)) return <Navigate to={notFound.path} replace />;

  return (
    <Page
      id="payment-checkout"
      headerId="page.payment.payment.title"
      fetchData={fetchInfo}
      hideHeader
    >
      <Box display="flex" justifyContent="center">
        <Box width="100%" maxWidth={680} pt={5} pb={9}>
          <Typography className={classes.pageTitle}>
            <FormattedMessage id="page.payment.v2.title" />
          </Typography>
          <Typography className={classes.pageSubtitle}>
            <FormattedMessage id="page.payment.v2.subtitle" />
          </Typography>
          <PaymentMethodSection accountId={accountId} />
          <BillingInfoSection accountId={accountId} />
        </Box>
      </Box>
    </Page>
  );
};

export default PaymentMethod;
